import { render, staticRenderFns } from "./WebPartHRSetting.vue?vue&type=template&id=1da6812c&"
import script from "./WebPartHRSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartHRSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports